import { Distribute, Icon, Spacer, SvgZap, Text, Tooltip } from '@loomhq/lens';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { WORKSPACE_PLAN_BUSINESS } from 'constants/workspacePlans';
import { getUpgradeRequestStatus, requestUpgrade } from 'creators/upgrades';
import { getTooltipMessage } from 'utilities/upgrades';

import { useGetSelectedWorkspace } from 'hooks/workspace';

const UpgradeTooltip = ({
  analyticsEvent = null,
  children,
  minPlanForFeature = WORKSPACE_PLAN_BUSINESS,
  placement = 'bottomCenter',
  title,
}) => {
  const dispatch = useDispatch();
  const selectedWorkspace = useGetSelectedWorkspace();
  const requestStatus = useSelector(state => state.upgrades.requestStatus);
  const requestStatusFetching = useSelector(state => state.upgrades.fetching);
  const requestStatusFetched = useSelector(state => state.upgrades.fetched);

  useEffect(() => {
    if (!requestStatusFetching && !requestStatusFetched) {
      dispatch(getUpgradeRequestStatus());
    }
  }, [dispatch, requestStatusFetched, requestStatusFetching]);

  return (
    requestStatusFetched && (
      <Tooltip
        placement={placement}
        maxWidth={46}
        isInline={false}
        keepOpen
        content={
          <div className={classNames('theme-dark')}>
            <Distribute isSpread>
              <Text size="small" fontWeight="bold">
                {requestStatus ? 'Your request has been sent!' : title}
              </Text>
              <Distribute>
                <Icon color="upgrade" size={2} icon={<SvgZap />} />
                <Spacer left={0.5} />
                <Text color="upgrade" fontWeight="bold" size="small">
                  Upgrade
                </Text>
              </Distribute>
            </Distribute>
            <Spacer bottom={1} />
            <Text size="small">
              {getTooltipMessage({
                selectedWorkspace,
                minPlanForFeature,
                requestStatus,
              })}
            </Text>
          </div>
        }
      >
        <div
          className="disabledButtonWrapper pointer"
          onClick={() =>
            dispatch(
              requestUpgrade({
                analyticsEvent,
                selectedWorkspace,
                minPlanForFeature,
              })
            )
          }
          role="button"
          tabIndex={0}
        >
          {children}
        </div>
      </Tooltip>
    )
  );
};

export default UpgradeTooltip;
